import { render, staticRenderFns } from "./AdminPage2.vue?vue&type=template&id=7da170a3"
import script from "./AdminPage2.vue?vue&type=script&lang=js"
export * from "./AdminPage2.vue?vue&type=script&lang=js"
import style0 from "./AdminPageModern.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Basic.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports